import React from "react";
import ReactDOM from "react-dom";
import { inject, observer } from "mobx-react";
import _ from "lodash";
import reactCSS from "reactcss";
import classNames from "classnames";
import Dropdown from "component/atoms/Dropdown";
/// Functions
import PopupDICOMTags from "component/molecules/popupDICOMTags";
import OverlayTrigger from "component/atoms/OverlayTrigger";
//import { SketchPicker, ChromePicker, TwitterPicker } from "react-color";
import ColorPicker from "component/molecules/ColorPicker";
/// message dispatcher
//import Config from "core/config";
import Popover from "component/atoms/Popover";
import Config from "config";
import Helper from "helper";
import SVGIcons from "assets/icon";
import Constants from "constants/index";
function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

const styles = reactCSS({
  default: {
    card: {
      borderWidth: "4px",
      borderColor: "rgb(103,107,129)",
      borderRadius: "8px",
    },
  },
});

/**
 * @description Contrast 버튼 클릭시 나타나는 확장 메뉴. UI Component Container
 * @function ContrastDropdownMenu
 */
@inject("elementViewConfigStore")
@inject("toolbarStore")
@inject("hotkeyStore")
@inject("dialogStore")
@observer
class InfoDropdownContainer extends React.PureComponent {
  componentDidMount() {
    document.addEventListener("click", this.captureOuterMouseEvent, true);
  }
  componentWillUnmount() {
    document.removeEventListener("click", this.captureOuterMouseEvent);
  }
  captureOuterMouseEvent = (event) => {
    // @FIXME : 아래 수식 깔끔하게 수정하기
    //
    if (!!_.get(event, "toElement.closest") === false) {
      return;
    }

    const preventCloseElement = event.toElement.closest(
      ".no-close-after-selection"
    );
    // if (!!preventCloseElement === true) {
    //   const isOpen = preventCloseElement.className.split(" ").includes("show");
    //   if (isOpen === true) {
    //     event.stopPropagation();
    //     return;
    //   }
    // }

    const preventMouseRootCloseRef =
      !event.currentTarget ||
      isModifiedEvent(event) ||
      !isLeftClickEvent(event);

    if (preventMouseRootCloseRef === false && preventCloseElement === null) {
      const { dialogStore } = this.props;
      dialogStore.setShowColorPickerDialog(false);
    }
  };
  handleToggleAnnotation = (event) => {
    event.preventDefault();
    const { toolbarStore } = this.props;
    toolbarStore.toggleShowDCMDescription();
  };
  handleToggleAnnotationColorDialog = (event) => {
    event.preventDefault();
    //event.stopPropagation();
    const { dialogStore } = this.props;
    dialogStore.toggleShowColorPickerDialog();
  };
  handleChangingAnnotationColor = (color, event) => {
    const { elementViewConfigStore } = this.props;

    const newColor = _.get(color, "hex");
    const isColor = Helper.Validator.isHexColor(newColor);

    if (isColor === true) {
      elementViewConfigStore.setConfigAttribute("metadataTextColor", newColor);
      elementViewConfigStore.saveConfigAttributesInLocalStorage();
    }
    event.stopPropagation();
    event.preventDefault();
    //dialogStore.toggleShowColorPickerDialog(true);
  };

  handleToggleDICOMTags = (event) => {
    event.preventDefault();
    ///
    /// 1. 팝업 창 번호 지정
    ///
    let popup = window.open(
      Config.tagViewer.rootPageURL,
      "_blank",
      "width=1160,height=593,status=no ,location=no, scrollbars= 0, toolbar=0, menubar=no"
    );

    if (!popup) {
      return;
    }

    const dump = Config.rootStore.gridLayoutStore.getActiveDCMViewDump();
    const patientInfo = Config.rootStore.gridLayoutStore.getActiveDCMViewPatientInfo();

    ///
    /// 2. 팝업 생성시, DICOM Tag 리스트 뷰 렌더링
    ///
    function afterLoadWindow() {
      if (!popup) {
        return;
      }

      ReactDOM.render(
        <PopupDICOMTags
          patientName={patientInfo.patientName}
          modality={patientInfo.modality}
          studyDescription={patientInfo.studyDescription}
          dump={dump}
          windowObject={popup}
        />,
        popup.document.getElementById("root")
      );
      Helper.Style.copyStyles(window.document, popup.document);

      popup.removeEventListener("load", afterLoadWindow);
    }
    popup.addEventListener("load", afterLoadWindow, false);
  };

  /**
   * @method handleOpenDocument
   * @description 새 탭에 Webviewer Documentation 페이지를 연다
   */
  handleOpenDocument = (event) => {
    event.preventDefault();
    window.open(Config.documentation.rootPageURL, "_blank");
  };

  handleOpenAboutSoftware = (event) => {
    const { dialogStore } = this.props;
    event.preventDefault();
    dialogStore.setShowAboutSoftwareDialog(true);
  };

  /**
   * @method handleOpenDocument
   * @description 새 탭에 Webviewer Documentation 페이지를 연다
   */
  handleOpenKeyboardShortcutDocumentPage = (event) => {
    event.preventDefault();
    window.open(Config.documentation.shortkeyPageURL, "_blank");
  };

  /**
   * @method handleUserPreferences
   * @description
   */
  handleUserPreferences = (event) => {
    const { dialogStore } = this.props;
    event.preventDefault();
    dialogStore.setUserPreferencesDialog(true);
  };
  /**
   * @method renderDropdownMenu
   * @description dropdownmenu 렌더링
   */
  renderDropdownMenu() {
    const {
      toolbarStore,
      hotkeyStore,
      elementViewConfigStore,
      dialogStore,
    } = this.props;
    // 2. Metadata text color 속성 정보 획득
    let metadataTextColor = elementViewConfigStore.getConfigAttribute(
      "metadataTextColor"
    );
    // 만약, 획득한 color 가 유효한 hex color 가 아닌 경우, 기본값으로 지정
    if (Helper.Validator.isHexColor(metadataTextColor) === false) {
      metadataTextColor = Config.elementView.metadataTextColor;
    }

    const keymap = hotkeyStore.getKeysFromCommandName([
      "TOGGLE_ANNOTATION",
      "SHOW_DCM_TAG_TABLE",
      "SHOW_USER_PREFERENCES",
      "OPEN_SHORTCUT_PAGE_IN_DOCUMENTATION",
      "OPEN_DOCUMENTATION",
    ]);

    return (
      <Dropdown.Menu bsPrefix="dropdown-menu--toolbar">
        <Dropdown.Item
          bsPrefix="toolbar"
          className="dropdown-menu--toolbar__item__content"
          eventKey="1"
          //hotkey="T"
          hotkey={keymap["TOGGLE_ANNOTATION"].toUpperCase() || ""}
          activeIcon={SVGIcons.SVGDropdownCheckmarkIcon}
          onClick={this.handleToggleAnnotation}
          active={toolbarStore.isShowDCMDescription()}
          as="div"
        >
          Annotations Toggle
        </Dropdown.Item>
        <OverlayTrigger
          //trigger="click"
          show={dialogStore.getShowColorPickerDialog()}
          placement="right"
          overlay={
            <Popover
              id="popover-basic"
              style={styles.card}
              className={classNames("no-close-after-selection")}
            >
              <ColorPicker
                id="tooltip-disabled"
                triangle="hide"
                colors={Constants.Annotation.TextColorPalette}
                onChange={this.handleChangingAnnotationColor}
              />
            </Popover>
          }
        >
          <Dropdown.Item
            bsPrefix="toolbar"
            className="dropdown-menu--toolbar__item__content"
            eventKey="2"
            activeIcon={SVGIcons.SVGDropdownCheckmarkIcon}
            color={metadataTextColor}
            onClick={this.handleToggleAnnotationColorDialog}
            noCloseAfterSelect={true}
            as="div"
          >
            Annotations Color
          </Dropdown.Item>
        </OverlayTrigger>
        <Dropdown.Item
          bsPrefix="toolbar"
          className="dropdown-menu--toolbar__item__content"
          eventKey="3"
          //hotkey="I"
          hotkey={keymap["SHOW_DCM_TAG_TABLE"].toUpperCase() || ""}
          activeIcon={SVGIcons.SVGDropdownCheckmarkIcon}
          onClick={this.handleToggleDICOMTags}
          as="div"
        >
          DCM Tags
        </Dropdown.Item>
        <Dropdown.Item
          bsPrefix="toolbar"
          className="dropdown-menu--toolbar__item__content"
          eventKey="4"
          //hotkey="S"
          hotkey={
            keymap["OPEN_SHORTCUT_PAGE_IN_DOCUMENTATION"].toUpperCase() || ""
          }
          activeIcon={SVGIcons.SVGDropdownCheckmarkIcon}
          onClick={this.handleOpenKeyboardShortcutDocumentPage}
          as="div"
        >
          Keyboard Shortcuts
        </Dropdown.Item>
        <Dropdown.Item
          bsPrefix="toolbar"
          className="dropdown-menu--toolbar__item__content"
          eventKey="5"
          //hotkey="P"
          hotkey={keymap["SHOW_USER_PREFERENCES"].toUpperCase() || ""}
          activeIcon={SVGIcons.SVGDropdownCheckmarkIcon}
          onClick={this.handleUserPreferences}
          as="div"
        >
          User Preferences
        </Dropdown.Item>
        <Dropdown.Item
          bsPrefix="toolbar"
          className="dropdown-menu--toolbar__item__content"
          eventKey="6"
          //hotkey="F1"
          hotkey={keymap["OPEN_DOCUMENTATION"].toUpperCase() || ""}
          activeIcon={SVGIcons.SVGDropdownCheckmarkIcon}
          onClick={this.handleOpenDocument}
          as="div"
        >
          Documentation
        </Dropdown.Item>

        {/* <Dropdown.Item
          bsPrefix="toolbar"
          className="dropdown-menu--toolbar__item__content"
          eventKey="6"
          activeIcon={SVGIcons.SVGDropdownCheckmarkIcon}
          onClick={this.handleOpenAboutSoftware}
          as="div"
        >
          About Software
        </Dropdown.Item> */}
      </Dropdown.Menu>
    );
  }

  render() {
    return <React.Fragment>{this.renderDropdownMenu()}</React.Fragment>;
  }
}

export default InfoDropdownContainer;
